import ClinicSelection from './ClinicSelection';

export default ClinicSelection;
